module.exports = __webpack_public_path__ + "static/isoCertification-c468ec2d608679bf1a66402e19348258.png";